import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./css/bootstrap-5.1.3-dist/css/bootstrap.min.css";
// import "./css/ezy.css";
import App from "./App";
import "./css/main.css";

ReactDOM.render(
  <App />,

  document.getElementById("root")
);
